import React from "react";
import { Box } from "@mui/material";
import FilterBoxTile from "./FilterBoxTile";

const FilterBoxGroup = ({
  options = [],
  selected,
  onChange,
  multiSelect = false,
  gridTemplateColumns = "repeat(auto-fill, minmax(75px, 1fr))",
  gap = 1,
}) => {
  const isSelected = (val) => {
    if (multiSelect && Array.isArray(selected)) {
      return selected.includes(val);
    }
    return selected === val;
  };

  const handleTileClick = (val) => {
    if (multiSelect) {
      const current = Array.isArray(selected) ? [...selected] : [];
      if (current.includes(val)) {
        onChange(current.filter((item) => item !== val));
      } else {
        onChange([...current, val]);
      }
    } else {
      if (selected === val) {
        onChange(""); // Toggle off if already selected
      } else {
        onChange(val);
      }
    }
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: gridTemplateColumns,
        gap: gap,
        width: "100%",
      }}
    >
      {options.map((opt) => (
        <FilterBoxTile
          key={opt.value}
          label={opt.label}
          subtitle={opt.subtitle}
          badge={opt.badge}
          icon={opt.icon}
          selected={isSelected(opt.value)}
          onClick={() => handleTileClick(opt.value)}
        />
      ))}
    </Box>
  );
};

export default FilterBoxGroup;
